import DatePicker from 'app/common/ui/DatePicker';

export default DatePicker;
